/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUserSessionIssuersResult,
  ListUserSessionIssuersResult$inboundSchema,
} from "../components/listusersessionissuersresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListUserSessionIssuersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUserSessionIssuersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUserSessionIssuersSecurity = {
  option1?: ListUserSessionIssuersSecurityOption1 | undefined;
  option2?: ListUserSessionIssuersSecurityOption2 | undefined;
};

export type ListUserSessionIssuersRequest = {
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Optional MCP server or toolset resource ID used to authorize callers with resource-scoped mcp:write access. The resource must belong to the selected project.
   */
  mcpResourceId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListUserSessionIssuersResponse = {
  result: ListUserSessionIssuersResult;
};

/** @internal */
export type ListUserSessionIssuersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUserSessionIssuersSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListUserSessionIssuersSecurityOption1$Outbound,
    ListUserSessionIssuersSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listUserSessionIssuersSecurityOption1ToJSON(
  listUserSessionIssuersSecurityOption1: ListUserSessionIssuersSecurityOption1,
): string {
  return JSON.stringify(
    ListUserSessionIssuersSecurityOption1$outboundSchema.parse(
      listUserSessionIssuersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUserSessionIssuersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUserSessionIssuersSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListUserSessionIssuersSecurityOption2$Outbound,
    ListUserSessionIssuersSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listUserSessionIssuersSecurityOption2ToJSON(
  listUserSessionIssuersSecurityOption2: ListUserSessionIssuersSecurityOption2,
): string {
  return JSON.stringify(
    ListUserSessionIssuersSecurityOption2$outboundSchema.parse(
      listUserSessionIssuersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUserSessionIssuersSecurity$Outbound = {
  Option1?: ListUserSessionIssuersSecurityOption1$Outbound | undefined;
  Option2?: ListUserSessionIssuersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListUserSessionIssuersSecurity$outboundSchema: z.ZodMiniType<
  ListUserSessionIssuersSecurity$Outbound,
  ListUserSessionIssuersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListUserSessionIssuersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListUserSessionIssuersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listUserSessionIssuersSecurityToJSON(
  listUserSessionIssuersSecurity: ListUserSessionIssuersSecurity,
): string {
  return JSON.stringify(
    ListUserSessionIssuersSecurity$outboundSchema.parse(
      listUserSessionIssuersSecurity,
    ),
  );
}

/** @internal */
export type ListUserSessionIssuersRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  mcp_resource_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUserSessionIssuersRequest$outboundSchema: z.ZodMiniType<
  ListUserSessionIssuersRequest$Outbound,
  ListUserSessionIssuersRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    mcpResourceId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpResourceId: "mcp_resource_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listUserSessionIssuersRequestToJSON(
  listUserSessionIssuersRequest: ListUserSessionIssuersRequest,
): string {
  return JSON.stringify(
    ListUserSessionIssuersRequest$outboundSchema.parse(
      listUserSessionIssuersRequest,
    ),
  );
}

/** @internal */
export const ListUserSessionIssuersResponse$inboundSchema: z.ZodMiniType<
  ListUserSessionIssuersResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListUserSessionIssuersResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listUserSessionIssuersResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionIssuersResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionIssuersResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionIssuersResponse' from JSON`,
  );
}
